import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, TAGTypography, TAGLink, Icon, TAGSvgIcon, useMediaQuery } from '../../../..';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import ADFooterNavigationContent from './ADFooterNavigationContent';

var ADFooter = function ADFooter(props) {
  var contentfulData = props.contentfulData;
  var applicationName = contentfulData.name;
  var data = contentfulData.footer;
  var aboutDataParsed = JSON.parse(data.about.raw);
  var aboutDataContent = aboutDataParsed.content;
  var isADScheduling = applicationName === 'AspenDental - Scheduling';
  var theme = useTheme();
  var isLargeDevice = useMediaQuery('(min-width: 768px)');

  var footerText = function footerText(content) {
    var _contentFields$, _contentFields$2, _contentFields$3;

    var contentFields = content.content.map(function (subContent) {
      return subContent;
    });
    var elm1 = ((_contentFields$ = contentFields[0]) === null || _contentFields$ === void 0 ? void 0 : _contentFields$.nodeType) === 'text' ? contentFields[0].value : '';
    var elm2 = ((_contentFields$2 = contentFields[1]) === null || _contentFields$2 === void 0 ? void 0 : _contentFields$2.nodeType) === 'hyperlink' ? contentFields[1] : '';
    var elm3 = ((_contentFields$3 = contentFields[2]) === null || _contentFields$3 === void 0 ? void 0 : _contentFields$3.nodeType) === 'text' ? contentFields[2].value : '';
    return React.createElement(TAGTypography, {
      color: "text.light",
      variant: "bodySmallBook"
    }, elm1, ' ', elm2 && React.createElement(TAGLink, {
      href: elm2.data.uri,
      variant: "bodySmallBook",
      key: elm2.data.uri,
      underline: isADScheduling ? 'none' : 'always',
      color: "neutrals.white",
      sx: {
        display: 'inline'
      }
    }, elm2.content[0].value), ' ', elm3);
  };

  return React.createElement("footer", {
    style: {
      display: 'flex',
      backgroundColor: theme.palette.backgrounds.dark,
      marginTop: '15px'
    }
  }, React.createElement(Container, null, !isADScheduling && React.createElement(TAGLink, {
    title: "Back to top",
    sx: {
      position: 'relative',
      top: '-12px',
      display: 'inline-block',
      textAlign: 'center',
      '&:hover > span > div > span:first-of-type': {
        border: '2px solid #fc7900'
      }
    }
  }, React.createElement("div", {
    style: {
      position: 'absolute'
    }
  }, React.createElement(Icon, {
    sx: {
      marginBottom: '-10px',
      backgroundColor: 'secondary.main',
      border: '2px solid #fff',
      borderRadius: '50%'
    }
  }, React.createElement(TAGSvgIcon, {
    icon: "ArrowScrollToTop",
    viewBox: "0 0 21 20",
    size: 19,
    color: theme.palette.backgrounds.default
  })), React.createElement(TAGTypography, {
    variant: "lowestLevel",
    sx: {
      color: 'text.light',
      fontSize: '9px',
      justifyContent: 'center',
      marginTop: '5px'
    }
  }, "TOP"))), React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    spacing: 3,
    sx: {
      padding: isADScheduling || !isLargeDevice ? '30px 0' : '45px 0px 30px 30px'
    }
  }, React.createElement(ADFooterNavigationContent, {
    navigationGroups: data.navigationGroups,
    isADScheduling: isADScheduling
  }), !isADScheduling && React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBold",
    color: "text.light"
  }, "Follow us")), React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 4,
    justifyContent: "center",
    alignItems: "center"
  }, data.socialNetworks.map(function (socialNetwork) {
    var _socialNetwork$image, _socialNetwork$image$;

    return React.createElement(Grid, {
      item: true,
      key: socialNetwork.id
    }, React.createElement(TAGLink, {
      href: socialNetwork.path,
      color: "neutrals.white"
    }, React.createElement("img", {
      src: (_socialNetwork$image = socialNetwork.image) === null || _socialNetwork$image === void 0 ? void 0 : (_socialNetwork$image$ = _socialNetwork$image.file) === null || _socialNetwork$image$ === void 0 ? void 0 : _socialNetwork$image$.url
    })));
  })))), !isADScheduling && React.createElement(Grid, {
    item: true,
    key: data.contactNumber
  }, React.createElement(TAGLink, {
    href: "tel:".concat(data.contactNumber),
    variant: "h4"
  }, React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    spacing: 1,
    sx: {
      color: 'neutrals.white',
      fontSize: isLargeDevice ? '22px' : '14px'
    }
  }, React.createElement(Grid, {
    item: true,
    sx: {
      position: 'relative',
      top: '4px'
    }
  }, React.createElement(Icon, null, React.createElement(PhoneIphoneIcon, null))), React.createElement(Grid, {
    item: true
  }, data.contactNumber)))), isADScheduling && React.createElement(Grid, {
    item: true,
    key: data.copyright
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBook",
    color: "text.light",
    sx: {
      textAlign: 'center',
      justifyContent: 'center',
      display: 'flex'
    }
  }, data.copyright)), React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center"
  }, aboutDataContent.map(function (content, index) {
    return React.createElement(Grid, {
      item: true,
      textAlign: "center",
      key: "".concat(content.nodeType, " - ").concat(index)
    }, footerText(content));
  })))));
};

export default ADFooter;